import styled from 'styled-components'

import { Image, WorkspaceLogo } from '@sketch/components'
import { ReactComponent as TrashSvg } from '@sketch/icons/trash-empty-prism-16'

import { HAIRLINE_SHADOW, TILE_MEDIA_SIZE } from './constants'

/** Glyph shown in the icon tile of a trashed / permanently-deleted preview. */
export const TrashIcon = styled(TrashSvg)`
  width: 36px;
  height: 36px;
`

/**
 * 2×2 grid of a folder's document thumbnails, sized to fill a preview tile.
 * Mirrors the list-item `SubjectFolderGrid` so the inbox list and the preview
 * panel show a folder's contents the same way, scaled up to the tile size.
 */
export const FolderGrid = styled.div`
  box-sizing: border-box;
  width: ${TILE_MEDIA_SIZE};
  height: ${TILE_MEDIA_SIZE};
  margin-bottom: 10px;
  border-radius: 12px;
  overflow: hidden;

  padding: 4px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 4px;

  background: ${({ theme }) => theme.colors.background.tertiary.C};
  box-shadow: ${HAIRLINE_SHADOW};
`

export const FolderTile = styled.div`
  min-width: 0;
  min-height: 0;
  border-radius: 7px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.background.secondary.C};
`

export const FolderTileImage = styled(Image)`
  width: 100%;
  height: 100%;
`

export const FolderTileIcon = styled.div`
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  opacity: 0.3;

  > svg {
    width: 16px;
    height: 16px;
    display: block;
  }
`

export const WorkspaceTile = styled(WorkspaceLogo)`
  margin-bottom: 8px;

  &::after {
    border-radius: 12px;
  }
`
